import { red, teal } from '@mui/material/colors'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'

const textPrimary = '#222'
const textSecondary = '#444'

const _theme = createTheme()
export const theme = createTheme({
  palette: {
    primary: teal,
    secondary: red,
    error: red,
    text: {
      primary: textPrimary,
      secondary: textSecondary,
    },
    background: {
      default: '#eee',
      paper: '#fff',
    },
    divider: 'rgba(0,0,0,0.15)',
  },
  spacing: 8,
  typography: {
    h1: { fontSize: 22, colog: textPrimary },
    h2: { fontSize: 20, color: textPrimary },
    h3: { fontSize: 18, color: textPrimary },
    body1: { fontSize: 16, color: textPrimary },
    body2: { fontSize: 16, color: textSecondary },
    caption: { fontSize: 12, color: textSecondary },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          background: '#fff',
          borderRadius: 4,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: { width: '100%' },
        paper: {
          width: '100%',
          [_theme.breakpoints.down('sm')]: {
            margin: 0,
            borderRadius: 0,
            maxHeight: '100%',
          },
        },
        container: { width: '100%' },
      },
    },
    // https://github.com/mui/material-ui/issues/27851#issuecomment-1126966803
    MuiDialogContent: {
      styleOverrides: {
        root: { paddingTop: '20px !important' },
      },
    },
  },
})

export default function ThemeProvider({ children }) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}
